export const RQ_GET_ALL_USER_API = {
  url: 'api/user/lookup/all',
  method: 'GET',
  auth: true,
};

export const RQ_ADD_USER_API = {
  url: 'api/user/register',
  method: 'POST',
  auth: true,
};
